module.exports = __webpack_public_path__ + "static/media/26PerformancePhotos.82aa1eaa.jpeg";